import React from 'react';
import styles from '../css/index.module.scss';
import InformingBlockTitle from '../../../components/InformingBlockTitle';
import MyInput from '../../../components/MyInput';
import IconButton from '../../../components/IconButton';
import MyButton from '../../../components/MyButton';
import CloseIcon from '../../../assets/formIcons/close.svg';
import useIntegrationAdditionalPhones from '../../../hooks/UseIntegrationAdditionalPhones';

function AdditionalPhonesBlock() {
  const { values, events } = useIntegrationAdditionalPhones();

  if (!values.maxAdditionalPhones) return null;

  return (
    <div className={styles.additionalPhonesBlock}>
      <div className={styles.inputBlock}>
        <InformingBlockTitle
          title="Информирование"
          titleClassName={styles.inputBlockTitle}
          className={styles.inputBlockTitleRow}
        />
        {values.additionalPhones.map((phoneVal, index) => (
          <div className={styles.additionalPhoneRow} key={`integration-additional-phone-${index}`}>
            <MyInput
              wrapperClassName={styles.input}
              value={phoneVal}
              onChange={events.setAdditionalPhoneAt(index)}
              labelTextTop={`Телефон ${index + 1}`}
              withLeftIcon={false}
              mask="+7 999 999 99 99"
              disabled={values.loading || values.saving}
            />
            <IconButton
              onClick={events.onRemoveAdditionalPhoneClick(index)}
              svgPath={CloseIcon}
              wrapperClassName={styles.additionalPhoneRemove}
              loading={values.loading || values.saving}
            />
          </div>
        ))}
        {values.additionalPhones.length < values.maxAdditionalPhones && (
          <div className={styles.addPhoneButtonRow}>
            <MyButton
              text="Добавить номер"
              secondary
              onClick={events.onAddAdditionalPhoneClick}
              disabled={values.loading || values.saving}
            />
          </div>
        )}
        <div className={styles.additionalPhonesSaveRow}>
          <MyButton
            text="Сохранить"
            onClick={events.onSaveClick}
            loading={values.saving}
            disabled={values.loading}
          />
        </div>
      </div>
    </div>
  );
}

export default AdditionalPhonesBlock;
